export const uxDesignerConfig = {
  id: 'ux-designer',
  icon: 'Palette',
  color: 'purple',
  title: 'UX Designer',
  description: 'Design user-centered experiences',
  department: 'Design',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux']
};
